import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import SatelliteToggle from '../tabbedFlyout/SatelliteToggle';
import VerticalGotoMenu from './VerticalGotoMenu';

import '../../../css/LeftRail.scss';

/**
 * Container for left-edge navigation tabs. This is the single, ordered home for
 * tabs anchored to the left of the content area. The GO TO menu is the top-most
 * (first) entry and always renders above any other left-side tab.
 *
 * Other left-side tabs (Directions, the align/score/notes Flyout when flipped
 * left, etc.) can be migrated into this container over time so that left-tab
 * ordering and stacking live in one place instead of per-component absolute
 * positioning.
 */
const LeftRail = observer(() => {
  const {
    lessonManager
  } = useContext(MobXProviderContext);

  const showVerticalGoto = !!lessonManager.lessonOptions?.hasVerticalGotoMenu;

  return (
    <div className='left-rail'>
      {showVerticalGoto && <VerticalGotoMenu />}
      <SatelliteToggle />
    </div>
  );
});

export default LeftRail;
